import React, { Component } from "react";
import { connect } from "react-redux";
import { mapKV } from "../utils/map";
import { vrTypesToString } from "../utils/appUtils";
import { ManagedAppInfoDialog } from "../dialogs/ManagedAppInfoDialog";
import { AreYouSureDialog } from "../dialogs/AreYouSureDialog";
import AddManagedApp from "../containers/AddManagedApp";
import EditManagedApp from "../containers/EditManagedApp";
import UploadingFilesProgress from "../containers/UploadingFilesProgress";
import { ErrorDialog } from "../dialogs/ErrorDialog";
import { clearErrors } from "../redux/actions/uiActions";
import { deleteApp } from "../redux/actions/appActions";
import { isCurrentUserSuperAdmin } from "../utils/userRoles";
import { MANAGED_APPS, createInfoUrl } from "../utils/routes";
import AppsTable from "../components/AppsTable";


export class managedAppsPage extends Component {
  state = {
    showAddDialog: false,
    showEditDialog: false,
    showAreYouSureDialog: false
  };

  headers = () => {
    let h = [
      { id: 0, title: "", sortable: false },
      { id: 1, title: "Title", sortable: true },
      { id: 2, title: "Package Name", sortable: true },
      { id: 3, title: "Version", sortable: true },
      { id: 4, title: "Version Name", sortable: true },
      { id: 5, title: "VR Type(s)", sortable: true }
    ];

    if (isCurrentUserSuperAdmin())
      h.push({ id: 3, title: "Organization", sortable: true });

    return h;
  };

  extractData = () => {
    const { apps, organizations } = this.props;
    let data = [];
    mapKV(apps, (key, { apkUrl, iconUrl, title, packageName, latestVersion, versionName, vrTypes, organizationRef }) => {
      if (!apkUrl) return;
      const vrTypesString = vrTypesToString(vrTypes);
      const row = [<img src={iconUrl} style={{ width: 50 }} />, title, packageName, latestVersion, versionName, vrTypesString];
      let searching = [title, packageName, vrTypesString].join(" ")

      if (isCurrentUserSuperAdmin()) {
        const orgName = organizations[organizationRef.id].name;
        row.push(orgName);
        searching += " " + orgName;
      }

      data.push({
        title,
        key,
        row,
        searching,
      });
    });
    return data;
  };

  render() {
    const { showAddDialog, showEditDialog, showAreYouSureDialog } = this.state;
    const {
      apps,
      uploading,
      uploadingTitle,
      loading,
      errorMessage,
      clearErrors,
      deleteApp
    } = this.props;

    const { history, match } = this.props;
    const { selectedKey } = match.params;

    return (
      <div>
        {errorMessage !== "" && (
          <ErrorDialog
            title={"New Managed App"}
            message={errorMessage}
            onClose={() => {
              clearErrors();
              this.setState({ showAddDialog: true });
            }}
          />
        )}

        {showAddDialog && <AddManagedApp onClose={() => this.setState({ showAddDialog: false })} />}

        {selectedKey && apps[selectedKey] && !showEditDialog && (
          <ManagedAppInfoDialog
            onClose={() => history.push(MANAGED_APPS)}
            onEdit={() => this.setState({ showEditDialog: true })}
            onDelete={() => {
              this.setState({ showAreYouSureDialog: true });
            }}
            app={apps[selectedKey]}
            loading={loading}
          />
        )}

        {showAreYouSureDialog && (
          <AreYouSureDialog
            onClose={() => this.setState({ showAreYouSureDialog: false })}
            onDelete={() => {
              this.setState({ showAreYouSureDialog: false });
              history.push(MANAGED_APPS);
              deleteApp(selectedKey);
            }}
            title={apps[selectedKey].title}
          />
        )}

        {showEditDialog && (
          <EditManagedApp
            dialogTitle={"Managed App: " + apps[selectedKey].title}
            onClose={() => this.setState({ showEditDialog: false })}
            app={apps[selectedKey]}
            selectedKey={selectedKey}
          />
        )}

        {uploading && <UploadingFilesProgress title={uploadingTitle} />}

        <AppsTable
          onAddNewClick={() => this.setState({ showAddDialog: true })}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    apps: state.data.apps,
    loading: state.ui.loading,
    uploading: state.ui.uploading,
    uploadingTitle: state.ui.uploadingTitle,
    errorMessage: state.ui.errorMessage,
    organizations: state.data.organizations
  };
};

const mapDispatchToProps = { clearErrors, deleteApp };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(managedAppsPage);
